import * as React from 'react';

import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';

import InfoIcon from '../../../common/assets/icons/info_icon.svg';
import NoPreviewIcon from '../../../common/assets/icons/no_preview_icon.svg';
import StyledPopover from '../../../common/components/StyledPopover';
import { User } from '../../../common/types/User';
import { UserMenuOptions } from '../../constants/UserMenuOptions';

type Props = {
  handleClose: () => void;
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  user: User | null;
  id?: string;
  handleSelectedItem: (item: UserMenuOptions) => void;
};

const PopupMenu: React.FC<Props> = ({
  handleClose,
  anchorEl,
  open,
  user,
  id,
  handleSelectedItem,
}) => {
  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
    >
      <MenuList>
        <MenuItem onClick={() => handleSelectedItem(UserMenuOptions.MoreInfo)}>
          <ListItemIcon>
            <img src={InfoIcon} alt='' />
          </ListItemIcon>
          <Typography>{UserMenuOptions.MoreInfo}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => handleSelectedItem(UserMenuOptions.DisableUser)}
        >
          <ListItemIcon>
            <img src={NoPreviewIcon} alt='' />
          </ListItemIcon>
          <Typography>
            {user?.active ?? false ? 'Disable User' : 'Enable User'}
          </Typography>
        </MenuItem>
      </MenuList>
    </StyledPopover>
  );
};

export default PopupMenu;
